// extracted by mini-css-extract-plugin
module.exports = {"singleCta":"SingleCtaOutlet_singleCta__ut9y4","active":"SingleCtaOutlet_active__OFYiN"};